export default __webpack_public_path__ + "static/media/logo.680ff7c2.png";